import React, { useState, useEffect } from "react";
import {
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
  InputRightElement,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { useI18n } from "@/hooks/useI18n";

const ValidatedInput = ({
  label,
  placeholder,
  initialValue = "",
  validate,
  onChange,
  required = false,
}) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(undefined);
  const [touched, setTouched] = useState(false);

  const { t } = useI18n();

  // 验证函数
  const validateField = (inputValue) => {
    if (required && !inputValue.trim()) {
      return t("QZCxVURndUpletXFScR");
    }
    return validate ? validate(inputValue) : undefined;
  };

  // 输入变化处理
  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    setTouched(true);

    // 实时验证
    const error = validateField(newValue);
    setError(error);

    // 回调
    if (onChange) {
      onChange(newValue, !error);
    }
  };

  // 清除输入
  // const handleClear = () => {
  //   setValue("");
  //   setError(required ? "此项为必填项" : undefined);
  //   setTouched(true);
  //   if (onChange) {
  //     onChange("", !required);
  //   }
  // };

  // 失去焦点时验证
  const handleBlur = () => {
    if (!touched) setTouched(true);
    const error = validateField(value);
    setError(error);
  };

  // 重置状态
  const reset = () => {
    setValue("");
    setError(undefined);
    setTouched(false);
  };

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <FormControl isInvalid={touched && !!error} isRequired={required}>
      {label && (
        // <FormLabel mb={2} fontSize="sm" fontWeight="medium" color="gray.700">
        //   {label}
        // </FormLabel>
        <Text fontSize="14px">{label}</Text>
      )}

      <InputGroup>
        <Input
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          // 基础样式
          // border="2px solid"
          // borderColor={touched && error ? "red.300" : "gray.200"}
          // borderRadius="md"
          // bg={touched && error ? "red.50" : "white"}
          // fontSize="md"
          // height="44px"
          // _placeholder={{
          //   color: "gray.400",
          //   fontSize: "md",
          // }}
          width={"100%"}
          h="44px"
          fontSize="14px"
          color="#010313;"
          borderRadius={"12px"}
          mt="10px"
          borderWidth={1} // 设置边框宽度
          borderColor={touched && error ? "#D04457" : "#E4E6EF"} // 默认边框颜色
          errorBorderColor="transparent" // 禁用默认错误边框
          focusBorderColor="transparent" // 禁用默认聚焦边框
          _placeholder={{ color: "#B3B4C8" }}
          // 悬停状态
          _hover={{
            borderColor: touched && error ? "#D04457" : "gray.300",
          }}
          // 聚焦状态
          _focus={{
            borderColor: touched && error ? "#D04457" : "blue.500",
            bg: touched && error ? "#FCEDEF" : "white",
            boxShadow: "none", // 移除默认阴影
            // boxShadow:
            //   touched && error
            //     ? "0 0 0 3px rgba(245, 101, 101, 0.1)"
            //     : "0 0 0 3px rgba(66, 153, 225, 0.1)",
          }}
          // 禁用状态
          _disabled={{
            bg: "gray.50",
            borderColor: "gray.200",
            cursor: "not-allowed",
          }}
          // 错误状态 - 防止默认样式干扰
          _invalid={{
            borderColor: "#D04457",
            _focus: {
              borderColor: "#D04457",
              borderWidth: "1px",
            },
          }}
        />

        {/* {value && (
          <InputRightElement h="100%">
            <IconButton
              aria-label="清除输入"
              icon={<CloseIcon />}
              size="sm"
              variant="ghost"
              onClick={handleClear}
              color="gray.400"
              _hover={{ color: "gray.600", bg: "transparent" }}
            />
          </InputRightElement>
        )} */}
      </InputGroup>

      {touched && error && (
        <FormErrorMessage
          display="flex"
          alignItems="center"
          color="#D04457"
          fontSize="12px"
          mt={"8px"}
          fontWeight="normal"
        >
          {error}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default ValidatedInput;
